export default "__VITE_ASSET__e8088b19__"